function nth<T>(arr: T[], index: string | number): T {
  if (!arr || !arr.length) {
    return undefined;
  }
  let idx = index === 'last' ? -1 : +index || 0;
  idx += idx < 0 ? arr.length : 0;
  return arr[idx];
}
export default nth;
